<template>
  <div class="about-page">
    <div class="main-content">
      <!-- Header组件 - 与 About/Contact 一致 -->
      <Header
        :showLogo="true"
        theme="light"
        :fixed="true"
        :showBorder="isScrolled"
        backgroundColor="transparent"
        @menu-open="menuOpen = true"
        @menu-close="menuOpen = false"
        iconColor="black"
        :logoShrink="isScrolled"
      />

      <!-- 顶部标题和描述 -->
      <div class="about-header">
        <div class="header-content" style="margin-top: 230rem;">
          <h1 class="page-title font-apercu-medium">Founder: Steven John Clark</h1>
          <div class="header-description">
            <p class="page-description font-apercu-medium" style="text-align: justify;">
              Steven John Clark is an artist and designer whose work has never followed a particularly straight line. A stonemason before studying fashion, sculptor and designer, his approach is instinctive but deeply informed, built
              over decades of working across disciplines processes and materials.
            </p>
          </div>
        </div>
      </div>

      <!-- 画廊与文本交替部分 -->
      <div class="alternating-sections">
        <!-- 第一部分: 图片在上，文字在下 -->
        <div class="alternating-section">
          <div class="gallery-grid" style="height: 930rem;">
            <div class="gallery-item small" >
              <img :src="workshop1" alt="Workshop Interior" class="gallery-image" />
            </div>

            <div class="gallery-item small" >
              <img :src="workshop2" alt="Workshop Detail" class="gallery-image" />
            </div>
          </div>

          <div class="header-description"
            style="max-width: 826rem;margin: auto;padding-top: 200rem;padding-bottom: 200rem;">
            <p class="page-description font-apercu-medium"  style="text-align: justify;">
            Founded in 2016, denHolm grew out of that somewhat unconventional path. Steven brings to each piece the knowledge of a stonemason and the curiosity of someone who has never been especially interested in doing things
            the expected way.
            </p>
          </div>
        </div>

        <!-- 第三部分: 单张大图 + 文字 -->
        <div class="full-width-section">
          <div class="studio-image">
            <img :src="stone1" alt="Studio Environment" class="gallery-image" />
            <div class="studio-text-overlay">
             <!-- <p class="font-bespoke-italic" style="font-size: 24rem;font-weight: 400;">
                “I don’t see myself working in the one medium for the rest of my life. The one simple fact of what makes
                me happy is that I know I can create.”
              </p> -->
            </div>
          </div>
        </div>
        <div class="header-description"
            style="max-width: 826rem;margin: auto;padding-top: 200rem;padding-bottom: 200rem;">
            <p class="page-description font-apercu-medium" style="text-align: justify;">
             For him, craftsmanship is not something applied at the end, but where the thinking begins. Every piece he made is
             considered without being overly polite, precise without becoming predictable, and always recognisably his.
            </p>
          </div>

        <div style="margin: 0rem 40rem; display: grid; grid-template-columns: 62.66% 37.34%; gap: 12rem;">
          <div>
            <img :src="workshop5" alt="Workshop Detail" class="gallery-image" style="height:100%;max-height: 801rem;width: 100%;" />
          </div>
          <div class="last-description">
            <img :src="workshop4" alt="Workshop Detail" class="gallery-image" style="height:100%;max-height: 801rem;width: 100%;" />
          </div>
        </div>
      </div>

      <!-- Footer组件 -->
      <Footer layout="about" :show-general-enquires="true" :show-instagram="true" :show-studio="true" style="margin-top: 45rem;"
        :show-decoration="true" @subscribe="handleSubscribe" />
    </div>

    <!-- 右侧固定区域 -->
    <!-- <div class="fixed-sidebar" :class="{ 'active': isSidebarActive }">
      <img :src="sidebarImage" alt="Sidebar" class="sidebar-image" />
    </div> -->
    
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import dsc1 from '../assets/founder/founder1.jpg'
import dsc2 from '../assets/founder/founder2.jpg'
import dsc3 from '../assets/founder/founder3.jpg'
import dsc4 from '../assets/founder/founder4.jpg'
import dsc5 from '../assets/founder/founder5.jpg'
import sidebarImg from '../assets/founder/founder_slip.png'

export default {
  name: 'FounderPage',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      menuOpen: false,
      isScrolled: false,   // 滚动状态，控制 Logo 缩小和边框
      workshop1: dsc1,
      workshop2: dsc2,
      workshop3: dsc3,
      workshop4: dsc4,
      workshop5: dsc5,
      stone1: dsc3,
      stone2: dsc4,
      sidebarImage: sidebarImg,
      isSidebarActive: false,
      sidebarTimer: null
    }
  },
  mounted() {
    // ✅ 与 About/Contact 一致：监听 window 滚动
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()

    // 启动初始闲置检测
    this.startIdleCycle()

    // 添加用户交互监听
    this.addInteractionListeners()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    this.removeInteractionListeners()
    if (this.sidebarTimer) {
      clearTimeout(this.sidebarTimer)
    }
    document.body.style.overflow = ''
  },
  methods: {
    // ✅ 与 About/Contact 一致的滚动处理
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0
      this.isScrolled = scrollTop > 50
    },
    onMenuOpen() {
      this.menuOpen = true
    },
    onMenuClose() {
      this.menuOpen = false
    },
    addInteractionListeners() {
      const events = ['mousedown', 'mousemove', 'wheel', 'touchstart', 'keydown']
      events.forEach(event => {
        window.addEventListener(event, this.handleUserInteraction, { passive: true })
      })
    },
    removeInteractionListeners() {
      const events = ['mousedown', 'mousemove', 'wheel', 'touchstart', 'keydown']
      events.forEach(event => {
        window.removeEventListener(event, this.handleUserInteraction)
      })
    },
    startIdleCycle() {
      if (this.sidebarTimer) {
        clearTimeout(this.sidebarTimer)
      }
      this.sidebarTimer = setTimeout(this.openSidebar, 3000)
    },
    openSidebar() {
      this.isSidebarActive = true
      this.sidebarTimer = setTimeout(this.closeSidebar, 4500)
    },
    closeSidebar() {
      this.isSidebarActive = false
      this.sidebarTimer = setTimeout(this.openSidebar, 4500)
    },
    handleUserInteraction() {
      if (this.sidebarTimer) {
        clearTimeout(this.sidebarTimer)
        this.sidebarTimer = null
      }
      if (this.isSidebarActive) {
        this.isSidebarActive = false
      }
      this.sidebarTimer = setTimeout(this.openSidebar, 3000)
    },
    handleSubscribe(email) {
      console.log('Subscribing:', email)
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.about-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1a1a1a;
}

/* 布局样式 */
.main-content {
  width: 100%;
  position: relative;
}

.fixed-sidebar {
  position: fixed;
  left: 66.66%;
  top: 0;
  width: 0;
  height: 100vh;
  overflow: hidden;
  z-index: 1;
  transition: width 1.5s cubic-bezier(0.19, 1, 0.22, 1), z-index 0s 1.5s;
}

.fixed-sidebar.active {
  width: 33.34%;
  z-index: 900;
  transition: width 1.5s cubic-bezier(0.19, 1, 0.22, 1), z-index 0s 0s;
}

.sidebar-image {
  width: 33.34vw;
  height: 100%;
  object-fit: cover;
  object-position: left center;
}

/* 顶部标题区域 */
.about-header {
  max-width: 1400rem;
  margin: 0 auto;
  padding: 200rem 0 80rem 0;
}

.header-content {
  max-width: 826rem;
  margin: 0 auto;
}

.page-title {
  font-size: 24rem;
  font-weight: 700;
  margin: 0 0 40rem 0;
  color: #000;
  text-align: center;
}

.page-description {
  font-size: 16rem;
  color: #000;
  margin: 0;
  font-weight: 500;
  text-align: justify;
}

/* 画廊网格布局 */
.gallery-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12rem;
  padding: 0 28rem;
}

.gallery-image {
  width: 100%;
  height: 100%;
  max-height: 930rem;
  object-fit: cover;
  transition: transform 0.6s ease;
}

/* 文本块 */
.text-block {
  text-align: center;
}

.text-title {
  font-size: 28rem;
  font-weight: 400;
  margin: 0 0 20rem 0;
  color: #000;
}

.text-description {
  font-size: 17rem;
  color: #555;
  margin: 0;
  font-weight: 350;
}

/* 全宽区域 */
.studio-image {
  position: relative;
}

.studio-text-overlay {
  position: absolute;
  bottom: 125rem;
  left: 103rem;
  max-width: 600rem;
  text-align: left;
}

.studio-text-overlay p {
  color: #fff;
  font-size: 20rem;
  margin: 0;
}

.full-width-text {
  max-width: 600rem;
  margin: 60rem auto 0;
  text-align: center;
}

/* 底部区域 */
.about-footer {
  background: #ffffff;
  padding: 60rem 5% 60rem;
  margin-top: 80rem;
  border-top: 1rem solid #000;
}

.footer-content {
  height: 180rem;
  margin: 0 auto;
}

.mailing-list-section {
  max-width: 500rem;
}

.footer-title {
  font-size: 17rem;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 24rem 0;
  color: #000;
}

.footer-description {
  font-size: 16rem;
  margin: 0 0 40rem 0;
  color: #000;
  font-weight: 350;
}

.email-form {
  position: relative;
  padding-bottom: 8rem;
  border-bottom: 1.5rem solid #000;
  display: flex;
  align-items: center;
}

.email-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16rem;
  padding: 12rem 0;
  background: transparent;
  color: #000;
  font-weight: 350;
}

.email-input::placeholder {
  color: #888;
  font-weight: 350;
}

.submit-btn {
  background: none;
  border: none;
  font-size: 16rem;
  color: #000;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8rem;
  transition: opacity 0.3s ease;
}

.submit-btn:hover {
  opacity: 0.6;
}

.submit-text {
  font-weight: 350;
}

.submit-arrow {
  font-size: 20rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60rem;
}

.contact-column {
  display: flex;
  flex-direction: column;
}

.contact-items {
  display: flex;
  flex-direction: column;
  gap: 16rem;
}

.contact-link {
  font-size: 16rem;
  color: #000;
  text-decoration: none;
  font-weight: 350;
  transition: opacity 0.3s ease;
}

.contact-link:hover {
  opacity: 0.6;
}

.contact-text {
  font-size: 16rem;
  color: #555;
  margin: 0;
  font-weight: 350;
}

/* 底部装饰 */
.footer-decoration {
  margin: 40rem auto 0;
  text-align: right;
}

.flower-logo {
  width: 32rem;
  height: auto;
  opacity: 0.8;
  margin-bottom: 24rem;
  margin-right: 40rem;
}

.copyright {
  font-size: 14rem;
  color: #888;
  margin: 0;
  font-weight: 350;
}

.last-description {
  font-weight: 400;
  font-style: Italic;
  font-size: 24rem;
  leading-trim: NONE;
  text-align: justify;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 40rem;
  }
  .main-content {
    width: 100%;
  }
  .fixed-sidebar {
    display: none;
  }
}

@media (max-width: 768px) {
  .about-header {
    padding: 80rem 5% 60rem;
  }
  .page-title {
    font-size: 48rem;
  }
  .footer-content {
    grid-template-columns: 1fr;
    gap: 80rem;
  }
  .studio-image {
    height: 500rem;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 36rem;
  }
  .page-description,
  .text-description {
    font-size: 16rem;
  }
  .studio-image {
    height: 350rem;
  }
  .footer-title {
    font-size: 11rem;
  }
  .contact-link,
  .contact-text {
    font-size: 15rem;
  }
}

/* 左侧菜单栏 */
.sidebar-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 35%;
  height: 100%;
  z-index: 1000;
  overflow: hidden;
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 1024px) {
  .sidebar-wrap {
    width: 40%;
  }
}

@media (max-width: 768px) {
  .sidebar-wrap {
    width: 100%;
  }
}
</style>